@if (params.context.componentParent.isSelected(params.data.personId)) {
  <span class="text-muted">Added</span>
} @else {
  <button class="btn btn-primary btn-sm" (click)="select()">Select</button>
}
